import { render, staticRenderFns } from "./autoPublishing.vue?vue&type=template&id=24bd5b07&scoped=true&"
import script from "./autoPublishing.vue?vue&type=script&lang=js&"
export * from "./autoPublishing.vue?vue&type=script&lang=js&"
import style0 from "./autoPublishing.vue?vue&type=style&index=0&id=24bd5b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd5b07",
  null
  
)

export default component.exports